import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import theme from '../../../assets/stylesheets/_settings.global.scss';
import StockCodeFollowButton from './stock-code-follow-button';

const Banner = styled.header`
  display: block;
  background-color: #F1F3F8;
  width: 100%;
  z-index: 210;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  ${props => props.theme.isXXLarge && `
    width: 1200px;
  `};
  ${props => props.theme.isXLarge && `
    width: 953px;
  `};
  ${props => props.theme.isLarge && `
    width: 85%;
  `};
  ${props => props.theme.isMobileOrTablet && `
    width: 100%;
  `};
  padding: ${props => (props.theme.isMobileOrTablet ? '22px 20px 26px 20px' : '36px 0 40px 0')};
`;

const Name = styled.h1`
  color: ${props => props.theme.bodyColor};
  display: flex;
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  ${props => (props.theme.isMobileOrTablet ? `
    font-size: 34px;
    line-height: 44px;
    margin: 10px 0 10px 0;
  ` : `
    font-size: 40px;
    line-height: 52px;
    margin: 0;
  `)};
`;

const Desc = styled.p`
  color: #627484;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 16px;
  line-height: 130%;
  margin: 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${props => (props.theme.isMobileOrTablet
    ? `
      justify-content: space-between;
      padding: 8px 0;
    `
    : `
      width: 116px;
      margin-top: 25px;
    `
  )};
`;

export default function StockCodeHeader({ stockCode }) {
  const mediaQueries = {
    isXXLarge: useMediaQuery({ query: '(min-width: 1366px)' }),
    isXLarge: useMediaQuery({ query: '(min-width: 1025px)' }),
    isLarge: useMediaQuery({ query: '(min-width: 769px)' }),
    isMobileOrTablet: useMediaQuery({ query: '(max-width: 768px)' }),
  };

  const { companyName, code, stockExchange } = stockCode;

  const description = `Latest analysis and news on ${companyName} ${stockExchange} ${code}`;

  return (
    <ThemeProvider theme={{ ...theme, ...mediaQueries }}>
      <Banner>
        <Container>
          <Name>{companyName}</Name>
          <Desc>{description}</Desc>
          <ButtonContainer>
            <StockCodeFollowButton stockCode={stockCode} />
          </ButtonContainer>
        </Container>
      </Banner>
    </ThemeProvider>
  );
}

StockCodeHeader.propTypes = {
  stockCode: PropTypes.shape({
    stockExchange: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    companyName: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    isStockCodeFollowedByCurrentUser: PropTypes.bool.isRequired,
  }).isRequired,
};
